import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-payment-option1',
    templateUrl: './payment-option1.component.html',
    styleUrls: ['./payment-option1.component.scss'],
    standalone: false
})
export class PaymentOption1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
